module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-regular-400.ttf?323b749d60730fa9ab61ff2d70e1cc32";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf
// module id = pJ7a
// module chunks = 29